{
  "RESET_PASSWORD": {
    "TITLE": "Resetare parolă",
    "DESCRIPTION": "Introduceți adresa de e-mail cu care vă conectați la centrul de contact pentru a primi instrucțiunile de resetare a parolei.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Te rugăm să introduci adresa de e-mail.",
      "ERROR": "Te rugăm să introduci adresa de e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link-ul de resetare a parolei a fost trimis pe e-mail.",
      "ERROR_MESSAGE": "Nu s-a putut conecta la serverul Woot. Vă rugăm să încercați din nou."
    },
    "SUBMIT": "Trimite"
  }
}
